import * as React from "react";

const { Component } = React;

import { toPairs } from "lodash";

import * as IdentityProviderStore from "./IdentityProviderStore";
import { alert } from "../general/alertStore";
import { Input, FormGroup, Label, Button } from "../components/Modal";

interface CreateIdentityProviderProps {
    organization: string;
}

interface CreateIdentityProviderState {
    identityProvider: {
        id: string;
        sourceID: string;
        type: string;
        priority: number;
        organizationID: string;
    };
    isLoaded: boolean;
    error?: any;
}

export const IdentityProviderTypes = {
    "0": "Azure Active Directory",
    "1": "Google",
    "2": "Apple",
    "3": "Facebook",
};

export default class CreateIdentityProvider extends Component<CreateIdentityProviderProps, CreateIdentityProviderState> {
    constructor(props) {
        super(props);
        this.state = {
            identityProvider: {
                id: undefined,
                sourceID: undefined,
                type: undefined,
                priority: undefined,
                organizationID: props.organization,
            },
            isLoaded: false,
        };
    }

    createIdentityProvider = () => {
        if (!this.state.identityProvider.type) {
            alert("Choose a Identity Provider type");
            return;
        }

        IdentityProviderStore.CreateIdentityProvider(this.state.identityProvider).then(
            (result) => {
                this.setState({
                    isLoaded: true,
                    identityProvider: result,
                });
            },
            (error) => {
                this.setState({
                    isLoaded: true,
                    error,
                });
            }
        );
    };

    handleSourceIdChange = (e) => {
        var name = e.target.value;

        this.setState((prevState) => {
            prevState.identityProvider.sourceID = name;

            return prevState;
        });
    };

    handleTypeChange = (e) => {
        var name = e.target.value;

        this.setState((prevState) => {
            prevState.identityProvider.type = name;

            return prevState;
        });
    };

    handlePriorityChange = (e) => {
        var name = e.target.value;

        this.setState((prevState) => {
            prevState.identityProvider.priority = name;

            return prevState;
        });
    };

    render() {
        return (
            <div className="space-y-6">
                <FormGroup>
                    <Label>Source ID</Label>
                    <Input type="text" onChange={this.handleSourceIdChange} placeholder="Enter source ID" />
                </FormGroup>

                <FormGroup>
                    <Label required>Type</Label>
                    <Input type="select" onChange={this.handleTypeChange} defaultValue="">
                        <option value="">- Choose One -</option>
                        {toPairs(IdentityProviderTypes).map((pair) => (
                            <option value={pair[0]} key={pair[0]}>
                                {pair[1]}
                            </option>
                        ))}
                    </Input>
                </FormGroup>

                <FormGroup>
                    <Label>Priority</Label>
                    <Input type="text" onChange={this.handlePriorityChange} placeholder="Enter priority (e.g., 1, 2, 3)" />
                </FormGroup>

                <div className="flex justify-end">
                    <Button variant="primary" onClick={this.createIdentityProvider}>
                        Create Identity Provider
                    </Button>
                </div>
                {this.state.isLoaded && (
                    <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-md">
                        <h4 className="text-lg font-medium text-green-800 mb-4">Identity Provider Created Successfully</h4>
                        <div className="space-y-3">
                            <div>
                                <Label>ID</Label>
                                <div className="text-sm text-gray-900 font-mono">{this.state.identityProvider.id}</div>
                            </div>
                            <div>
                                <Label>Source ID</Label>
                                <div className="text-sm text-gray-900">{this.state.identityProvider.sourceID}</div>
                            </div>
                            <div>
                                <Label>Type</Label>
                                <div className="text-sm text-gray-900">{IdentityProviderTypes[this.state.identityProvider.type as keyof typeof IdentityProviderTypes]}</div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
